import React, { useMemo, useState } from 'react';

const footerSections = {
  about: {
    title: 'Sobre nosotros',
    category: 'Compañia',
    description: 'EduDigital conecta aprendizaje practico, cursos accesibles y pagos simples para estudiantes e instructores.',
    bullets: [
      'Mas de 8 categorias activas con cursos de ejemplo.',
      'Publicacion guiada para instructores nuevos.',
      'Experiencia pensada para pagos y acceso rapido.'
    ]
  },
  careers: {
    title: 'Carreras',
    category: 'Compañia',
    description: 'Estamos simulando vacantes para mostrar como cargaria esta seccion.',
    bullets: [
      'Frontend Developer React',
      'Diseñador UI para cursos online',
      'Especialista en soporte al estudiante'
    ]
  },
  blog: {
    title: 'Blog',
    category: 'Compañia',
    description: 'Contenido de ejemplo para novedades y articulos de la plataforma.',
    bullets: [
      'Como crear tu primer curso en 30 minutos.',
      '5 ideas de cursos con alta demanda local.',
      'Consejos para mejorar ventas y reseñas.'
    ]
  },
  contact: {
    title: 'Contacto',
    category: 'Soporte',
    description: 'Canales de ejemplo para atencion al usuario.',
    bullets: [
      'Email: contacto@sasceo.es',
      'WhatsApp: +591 75563490',
      'Horario: lunes a viernes de 08:30 a 18:30'
    ]
  },
  faq: {
    title: 'Preguntas frecuentes',
    category: 'Soporte',
    description: 'Respuestas de ejemplo para dudas comunes.',
    bullets: [
      '¿Como me inscribo? Selecciona un curso y confirma tu acceso.',
      '¿Como publico un curso? Entra al panel instructor y completa estructura y publicacion.',
      '¿Necesito pagar? Hay cursos gratis y otros con pago.'
    ]
  },
  help: {
    title: 'Centro de ayuda',
    category: 'Soporte',
    description: 'Recursos de ejemplo para soporte y onboarding.',
    bullets: [
      'Guia para estudiantes nuevos.',
      'Guia para instructores y carga de contenido.',
      'Pasos para resolver problemas de acceso.'
    ]
  },
  terms: {
    title: 'Términos',
    category: 'Legal',
    description: 'Texto legal resumido de ejemplo para mostrar esta vista.',
    bullets: [
      'El uso de la plataforma implica aceptacion de reglas de acceso.',
      'Los cursos publicados deben respetar contenido apropiado.',
      'Las cuentas pueden restringirse por uso indebido.'
    ]
  },
  privacy: {
    title: 'Privacidad',
    category: 'Legal',
    description: 'Resumen de ejemplo sobre manejo de datos.',
    bullets: [
      'Guardamos informacion basica de cuenta y actividad.',
      'No compartimos datos sensibles sin autorizacion.',
      'El usuario puede solicitar actualizacion de perfil.'
    ]
  },
  cookies: {
    title: 'Política de cookies',
    category: 'Legal',
    description: 'Informacion de ejemplo sobre cookies y sesion.',
    bullets: [
      'Usamos cookies para mantener sesion iniciada.',
      'Tambien ayudan a recordar preferencias del usuario.',
      'Puedes limitar su uso desde el navegador.'
    ]
  }
};

const footerColumns = [
  {
    title: 'Compañia',
    links: [
      { key: 'about', label: 'Sobre nosotros' },
      { key: 'careers', label: 'Carreras' },
      { key: 'blog', label: 'Blog' }
    ]
  },
  {
    title: 'Soporte',
    links: [
      { key: 'contact', label: 'Contacto' },
      { key: 'faq', label: 'Preguntas frecuentes' },
      { key: 'help', label: 'Centro de ayuda' }
    ]
  },
  {
    title: 'Legal',
    links: [
      { key: 'terms', label: 'Términos' },
      { key: 'privacy', label: 'Privacidad' },
      { key: 'cookies', label: 'Política de cookies' }
    ]
  }
];

const Footer = () => {
  const [activeKey, setActiveKey] = useState(null);

  const activeSection = useMemo(() => {
    if (!activeKey) return null;
    return footerSections[activeKey] || null;
  }, [activeKey]);

  return (
    <>
      <footer className="bg-gray-100 py-8 mt-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="font-bold text-lg mb-4">EduDigital</h3>
              <p className="text-gray-600">
                La mejor plataforma para aprender con pagos faciles mediante QR del BNB.
              </p>
            </div>

            {footerColumns.map((column) => (
              <div key={column.title}>
                <h4 className="font-bold mb-4">{column.title}</h4>
                <ul className="space-y-2">
                  {column.links.map((link) => (
                    <li key={link.key}>
                      <button
                        type="button"
                        onClick={() => setActiveKey(link.key)}
                        className="text-left text-gray-600 hover:text-blue-600"
                      >
                        {link.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-200 mt-8 pt-8 text-center text-gray-500">
            <p>© 2026 EduDigital. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>

      {activeSection ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 px-4">
          <div className="w-full max-w-2xl rounded-2xl bg-white shadow-2xl overflow-hidden">
            <div className="flex items-start justify-between gap-4 border-b border-gray-200 px-6 py-5">
              <div>
                <p className="text-sm font-semibold text-blue-600">{activeSection.category}</p>
                <h3 className="text-2xl font-bold text-gray-900 mt-1">{activeSection.title}</h3>
              </div>
              <button
                type="button"
                onClick={() => setActiveKey(null)}
                className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-800"
              >
                ✕
              </button>
            </div>

            <div className="px-6 py-5">
              <p className="text-gray-700 mb-5">{activeSection.description}</p>
              <div className="rounded-xl bg-slate-50 p-4">
                <p className="text-sm font-semibold text-slate-900 mb-3">Contenido de ejemplo</p>
                <ul className="space-y-2 text-slate-700">
                  {activeSection.bullets.map((item) => (
                    <li key={item} className="flex items-start gap-2">
                      <span className="mt-1 h-2 w-2 rounded-full bg-blue-500"></span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="flex justify-end border-t border-gray-200 px-6 py-4">
              <button
                type="button"
                onClick={() => setActiveKey(null)}
                className="rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default Footer;
